import React from "react";
import classNames from "classnames";
import { getColorByName } from "../../utils/color";
import { DarkNeutralsColorNames, StateColorNames, } from "../../theme";
import styles from "./Title.module.scss";
export const Title = (props) => {
    const hasActionIcon = Boolean(props.actionIcon);
    const hasActionText = Boolean(props.actionText);
    const hasOnlyActionIcon = hasActionIcon && !hasActionText;
    const hasOnlyActionText = !hasActionIcon && hasActionText;
    const hasIconAndTextAction = hasActionIcon && hasActionText;
    const hasNoAction = !hasActionIcon && !hasActionText;
    const Icon = props.actionIcon;
    const hasSuffixIcon = Boolean(props.suffixIcon);
    const SuffixIcon = props.suffixIcon;
    const isAfterIcon = props.actionIconPlace === "After";
    return (React.createElement("div", { className: classNames(styles.Container, {
            [styles.NoAction]: hasNoAction,
        }, props.className) },
        React.createElement("div", { className: styles.titleContainer },
            React.createElement("span", { className: classNames(styles.Title, props.titleClassName, {
                    [styles.ForceHeight]: hasNoAction,
                }) }, props.title),
            hasSuffixIcon && (React.createElement(SuffixIcon, { size: hasOnlyActionIcon ? 24 : 18, color: getColorByName(StateColorNames.color_link), onClick: props.suffixHandler, className: styles.suffixIcon }))),
        React.createElement("div", { className: classNames(styles.ActionWrapper, {
                [styles.IconOnly]: hasOnlyActionIcon,
                [styles.TextOnly]: hasOnlyActionText,
                [styles.IconText]: hasIconAndTextAction,
            }), onClick: props.actionHandler },
            isAfterIcon && hasActionIcon && (React.createElement(Icon, { size: hasOnlyActionIcon ? 24 : 18, color: getColorByName(DarkNeutralsColorNames.color_neutrals_n_300) })),
            hasActionText && (React.createElement("span", { className: classNames(styles.ActionText, {
                    [styles.PrimaryText]: hasIconAndTextAction,
                }) }, props.actionText)),
            !isAfterIcon && hasActionIcon && (React.createElement(Icon, { size: hasOnlyActionIcon ? 24 : 18, color: getColorByName(DarkNeutralsColorNames.color_neutrals_n_300) })))));
};
//# sourceMappingURL=Title.js.map